/**
 * Design tokens taken 1:1 from the "Fahrzeugdaten-Check" add-in stylesheet, so both pages look
 * like one product inside MyGeotab (spec section 8).
 */
export const AUDIT_TOKENS = {
  ink: "#17263F",
  inkHover: "#1F3355",
  bg: "#F4F6F9",
  surface: "#FFFFFF",
  surfaceHover: "#FBFCFE",
  rowHover: "#F8FAFD",
  line: "#E1E6EE",
  lineHover: "#C4CDDC",
  text: "#2A3549",
  muted: "#6B7690",
  version: "#A6AFC0",
  empty: "#B6BDCB",
  dashed: "#C3CAD7",
  accent: "#2A5BD7",
  ok: { fg: "#157A4C", bg: "#E3F4EA" },
  warn: { fg: "#8A6100", bg: "#FBF0D2" },
  alert: { fg: "#B23A2A", bg: "#FBE5E0" },
  none: { fg: "#8A93A6", bg: "#EEF1F6" },
  /** Colors of the "last communication" dot pattern. */
  dot: { fresh: "#1FA463", stale: "#E0A800", old: "#D14836", never: "#C3CAD7" },
  /** Map line colors per tax class. */
  map: { favored: "#157A4C", notFavored: "#2A5BD7", none: "#8A93A6" },
  fontFamily: '-apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  radius: { card: 12, control: 8, small: 6 },
  shadow: {
    panel: "0 8px 24px rgba(15,35,60,.14)",
    overlay: "0 16px 48px rgba(15,35,60,.25)",
  },
  focusRing: "2px solid #2A5BD7",
} as const;

export type StatusTone = "ok" | "warn" | "alert" | "none";
